import { useSelector } from 'react-redux';
import classNames from 'classnames';

import styles from './ErknmStatusHint.module.scss';
import { IconExclamationCircle } from '../../../UIPackage/IconsModule/components/IconExclamationCircle';
import { isLaterThanAdminSetting } from '../../../CorePackage/MainModule/validators/isLaterThanAdminSetting';
import { AdminSettingCodesEnum } from '../../../APIPackage/AdminModule/enums/AdminSettingCodesEnum';
import { getKnmData, getKnmErrorFields } from '../../MainModule/selectors/knmSelectors';
import { getAdminFetchSettings } from '../../../PersonalAccountPackage/AdminModule/selectors/adminSelectors';
import { scrollToBlock } from '../../../CorePackage/MainModule/common/scrollToBlock';
import {
  getKnmPmStatusHintFields,
  getKnmPmStatusHintText,
} from '../../../KnmPmPackage/MainModule/selectors/knmPmSelectors';

interface IPmStatusHintProps {
  isHover?: boolean;
}

export const PmStatusHint = ({ isHover }: IPmStatusHintProps) => {
  const errorFields = useSelector(getKnmErrorFields);
  const knmData = useSelector(getKnmData);
  const created = knmData?.created || undefined;
  const settings = useSelector(getAdminFetchSettings);
  const isShowByCreated = isLaterThanAdminSetting(created, settings, AdminSettingCodesEnum.FIELDS_MARKS_481_4_1_14);
  const hintText = useSelector(getKnmPmStatusHintText);
  const hintFields = useSelector(getKnmPmStatusHintFields);

  if (!isShowByCreated || errorFields?.length || (!hintText && !hintFields?.length)) {
    return null;
  }

  return (
    <div className={classNames(styles.StatusHint, { [styles.StatusHintHover]: isHover })}>
      <IconExclamationCircle className={styles.Icon} />
      <div className={styles.Content}>
        <div className={hintFields?.length ? styles.BorderBottom : ''}>{hintText}</div>
        {!!hintFields?.length && (
          <ul className={styles.List}>
            {hintFields.map((item, index) => (
              <li key={index}>
                <div onClick={() => scrollToBlock(item.scrollToId)}>{item.title}</div>
              </li>
            ))}
          </ul>
        )}
      </div>
    </div>
  );
};
